import React from 'react';
import './ChanTrang.css';

const ChanTrang = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">Game May Mắn</h3>
            <p className="footer-description">
              Game quay số may mắn hàng đầu Việt Nam. 
              Đã trao hơn 15 tỷ đồng cho 250,000+ người chơi. 
              Quay số miễn phí mỗi ngày, trúng ngay tiền thật!
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Liên Kết</h4>
            <ul className="footer-links">
              <li><a href="#about">Về Chúng Tôi</a></li>
              <li><a href="#terms">Điều Khoản</a></li>
              <li><a href="#privacy">Chính Sách Bảo Mật</a></li>
              <li><a href="#contact">Liên Hệ</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Hỗ Trợ</h4>
            <ul className="footer-links">
              <li><a href="#faq">Câu Hỏi Thường Gặp</a></li>
              <li><a href="#help">Hướng Dẫn</a></li>
              <li><a href="#support">Hỗ Trợ 24/7</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Kết Nối</h4>
            <div className="social-links">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Facebook">📘</a>
              <a href="https://zalo.me" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Zalo">💬</a>
              <a href="https://telegram.org" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Telegram">✈️</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Game May Mắn. Tất cả quyền được bảo lưu.
          </p>
          <p className="footer-license">
            Được cấp phép hoạt động hợp pháp • Bảo mật SSL
          </p>
        </div>
      </div>
    </footer>
  );
};

export default ChanTrang;

